// Generated by Ktorfit
@file:Suppress("warnings")

package one.healthium.insights.`data`.sources.network

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import one.healthium.insights.`data`.dto.ContentScreenDto

@OptIn(InternalKtorfitApi::class)
internal class _ContentApiClientImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : ContentApiClient {
  override suspend fun getScreenModel(categoryId: String, locale: String): ContentScreenDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "${"$locale".encodeURLPath()}/view_models/${"$categoryId".encodeURLPath()}.json")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<ContentScreenDto>(),)!! 
  }

  override suspend fun getInsight(insightId: String, locale: String): ContentScreenDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "${"$locale".encodeURLPath()}/insights/${"$insightId".encodeURLPath()}.json")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<ContentScreenDto>(),)!! 
  }

  override suspend fun getMealPlan(id: String, locale: String): ContentScreenDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "${"$locale".encodeURLPath()}/mealplans/${"$id".encodeURLPath()}.json")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<ContentScreenDto>(),)!! 
  }

  override suspend fun getWorkoutsScreen(locale: String): ContentScreenDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "${"$locale".encodeURLPath()}/view_models/workouts.json")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<ContentScreenDto>(),)!! 
  }

  override suspend fun getWorkout(id: String, locale: String): ContentScreenDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "${"$locale".encodeURLPath()}/workouts/${"$id".encodeURLPath()}.json")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<ContentScreenDto>(),)!! 
  }

  override suspend fun getRecipe(id: String, locale: String): ContentScreenDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "${"$locale".encodeURLPath()}/recipes/${"$id".encodeURLPath()}.json")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<ContentScreenDto>(),)!! 
  }
}

internal class _ContentApiClientProvider : ClassProvider<ContentApiClient> {
  override fun create(_ktorfit: Ktorfit): ContentApiClient = _ContentApiClientImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

internal fun Ktorfit.createContentApiClient(): ContentApiClient = _ContentApiClientImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
